import StyledWrapper from './style';

import Box from '@mui/material/Box';

const TabPanel = ({ children, value, index }) => {
	return (
		<StyledWrapper.TabPanel
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
		>
			{value === index && <Box sx={{ width: '100%' }}>{children}</Box>}
		</StyledWrapper.TabPanel>
	);
};

export default TabPanel;
